const translations = {
    validCity: 'Please enter a valid city'
};

export default translations;
